import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { fetchExpertReportBlocks } from './api';
import { expertReportKeys } from './hooks';
import type { ExpertReportBlocksResponse } from './types';

/** Соответствие reportId → ответ дерева блоков (дерево и вид итога) для уже загруженных заключений */
export type ExpertReportBlocksResponsesMap = Map<number, ExpertReportBlocksResponse>;

/**
 * Загружает деревья блоков указанных экспертных заключений и отдаёт `reportId → ответ` только
 * по уже пришедшим. Кэш общий на все хуки дерева блоков: один и тот же набор заключений,
 * запрошенный из нескольких мест страницы, грузится единожды.
 */
export const useExpertReportsBlocksResponses = (reportIds: number[]): ExpertReportBlocksResponsesMap => {
  const queries = useQueries({
    queries: reportIds.map((id) => ({
      queryKey: expertReportKeys.blocks(id),
      queryFn: () => fetchExpertReportBlocks(id),
      staleTime: 60_000,
    })),
  });

  return useMemo(() => {
    const map: ExpertReportBlocksResponsesMap = new Map();
    queries.forEach((q, index) => {
      if (q.data) map.set(reportIds[index], q.data);
    });
    return map;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queries.map((q) => q.dataUpdatedAt).join('|'), reportIds.join(',')]);
};
